import React from 'react'
import PropTypes from 'prop-types'
import { UIStore } from '../../stores'
import { inject, observer } from 'mobx-react'

@inject('uiStore')
@observer
class SidebarContainer extends React.Component {
  render () {
    return (
      <div className={`sidebar-container${this.props.uiStore.sidebarIsOpen ? '' : ' pull-left-toggle'}`}>
        {this.props.children}
      </div>
    )
  }
}

SidebarContainer.propTypes = {
  uiStore: PropTypes.instanceOf(UIStore),
  children: PropTypes.node.isRequired
}

export { SidebarContainer }
